module.exports = __webpack_public_path__ + "static/media/51_B.d9b27c9c.png";